module.exports = __webpack_public_path__ + "img/logo-VisionCRM.05b0dab9.svg";